/**
 * @generated SignedSource<<6d41c160af5b4183f7a6931bb0164c21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryLabelsInternal$data = {
  readonly id: string;
  readonly viewerCanPush: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"LabelList">;
  readonly " $fragmentType": "RepositoryLabelsInternal";
};
export type RepositoryLabelsInternal$key = {
  readonly " $data"?: RepositoryLabelsInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelsInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "ASC",
      "kind": "LocalArgument",
      "name": "orderDirection"
    },
    {
      "defaultValue": "NAME",
      "kind": "LocalArgument",
      "name": "orderField"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryLabelsInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "orderDirection",
          "variableName": "orderDirection"
        },
        {
          "kind": "Variable",
          "name": "orderField",
          "variableName": "orderField"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        }
      ],
      "kind": "FragmentSpread",
      "name": "LabelList"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "c90541c30a859c9cd0ac02793ab8d516";

export default node;
